import { css } from '@emotion/react';
import { useDropdown } from 'hooks/useDropdown';
import { useRef, useState } from 'react';
import { ScrollBarStyle } from 'styles/ScrollBarStyle';
import { theme } from 'styles/theme';
import { IconDone } from './ProcessStep';
import { Button } from './Button';
import { Spinner } from './Spinner';

export const MultiSelect = ({
	options,
	value,
	onChange,
	renderItem,
	error,
	sizeMedium,
	placeholder,

	isProcessing,
}) => {
	const [selected, setSelected] = useState([]);

	const dropdownRef = useRef<HTMLDivElement>(null);
	const [isOpen, toggle] = useDropdown(dropdownRef);

	const chosenLabels = options?.filter((option) => value.includes(option.value));

	const toggleOption = (val) => {
		const newValue = value.includes(val) ? value.filter((v) => v !== val) : [...value, val];

		onChange(newValue);
	};

	const resetOptions = () => {
		onChange([]);
	};

	return (
		<div
			ref={dropdownRef}
			css={css`
				position: relative;
				width: 100%;
			`}
		>
			<div
				css={css`
					height: ${sizeMedium ? 36 : 44}px;

					padding: ${sizeMedium ? '7px 12px' : '12px'};

					padding-right: 36px;

					border: 1px solid #d4d5de;
					border-radius: 8px;

					font-size: 14px;
					line-height: 20px;
					position: relative;
					background: #fff;

					white-space: nowrap;

					user-select: none;

					&:hover {
						background: ${theme.color.primary['50']};
						cursor: pointer;
					}

					${error &&
					css`
						border-color: #ff6767;
					`}

					${!value.length &&
					css`
						color: #8c8fa6;
					`}

					${isOpen &&
					css`
						box-shadow: 0 0 0 2px ${theme.color.primary['400']};
						border-color: transparent;
					`}
				`}
				onClick={toggle}
			>
				{isProcessing ? (
					<div
						css={css`
							color: ${theme.color.text[300]};

							svg {
								width: 20px;
								height: 20px;
							}
						`}
					>
						<Spinner />
					</div>
				) : (
					<>
						{!value.length ? (
							placeholder
						) : (
							<>
								{chosenLabels[0].label}

								{chosenLabels.length > 1 ? (
									<strong
										css={css`
											color: ${theme.color.text[300]};
										`}
									>
										{' '}
										+{chosenLabels.length - 1}
									</strong>
								) : (
									''
								)}
							</>
						)}
					</>
				)}

				{/* {JSON.stringify(chosenLabels)} */}

				<div
					css={css`
						position: absolute;

						top: ${sizeMedium ? 6 : 10}px;

						right: 16px;
						transition: all 0.2s ease-in-out;

						${isOpen &&
						css`
							top: ${sizeMedium ? 9 : 13}px;
							transform: rotateZ(180deg);
							transition: all 0.2s ease-in-out;
						`}
					`}
				>
					<svg
						width="10px"
						height="5px"
						viewBox="0 0 10 5"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
					>
						<g id="Booking" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
							<polygon
								id="Triangle"
								fill="#7F829C"
								transform="translate(5.000000, 2.500000) rotate(-180.000000) translate(-5.000000, -2.500000) "
								points="5 0 10 5 0 5"
							></polygon>
						</g>
					</svg>
				</div>
			</div>

			{isOpen && (
				<div
					css={css`
						position: absolute;
						left: 0;
						top: 100%;
						background: #fff;
						box-shadow: 0 20px 32px -8px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);
						min-width: 100%;
						border-radius: 8px;
						z-index: 1;
						margin-top: 2px;

						min-width: 320px;
					`}
				>
					<div
						css={[
							css`
								padding: 8px 0;
								max-height: 400px;
								overflow: auto;

								display: flex;
								flex-direction: column;
							`,
							ScrollBarStyle(),
						]}
					>
						{options.map((option) => {
							const isSelected = value.includes(option.value);

							return (
								<label
									key={option.value}
									css={css`
										padding: 8px 16px 8px 12px;
										margin: 2px 8px;
										border-radius: 8px;

										&:hover {
											background: ${theme.color.primary['50']};
											cursor: pointer;
										}
									`}
								>
									<input
										type="checkbox"
										value={option.value}
										checked={value.includes(option.value)}
										onChange={() => toggleOption(option.value)}
										css={css`
											display: none;
										`}
									/>

									<div
										css={css`
											display: flex;
											gap: 8px;
											align-items: center;
											justify-content: space-between;
										`}
									>
										{renderItem ? renderItem(option) : option.label}

										<div
											css={css`
												opacity: 0.2;

												${isSelected &&
												css`
													opacity: 1;
													color: ${theme.color.primary[400]};
												`};
											`}
										>
											<IconDone />
										</div>
									</div>
								</label>
							);
						})}
					</div>

					<div
						css={css`
							border-top: 1px solid #f0f0ff;
						`}
					>
						<Button onClick={resetOptions} ghost block type="button">
							Zrušit výběr
						</Button>
					</div>
				</div>
			)}
		</div>
	);
};
